<template>
    <ul class="list-unstyled">
        <li v-for="phone in phones">
            <a :href="`tel:${phone.phone}`">{{ phone.phone | phone }}</a>
            <label class="badge badge-info" style="font-size: 85%; font-weight: 400;" v-if="phone.is_primary">Primary</label>
            <label class="badge badge-default" style="font-size: 85%; font-weight: 400;" v-for="type in phone.phone_types">{{ type }}</label>
        </li>
    </ul>
</template>

<script>
    export default {
        props: {
            phones: {
                type: Array,
                required: true,
            }
        },

        data() {
            return {

            }
        },

        watch: {

        },

        computed: {

        },

        methods: {

        },

        mounted() {

        }
    }
</script>
